export default __webpack_public_path__ + "static/media/Michelle Bridges_12WBT_Purchase Page.82a0cf1f.png";